module.exports = __webpack_public_path__ + "img/download.7108c5c8.svg";